import apiService from "./apiService";
import { IPagination, IPaginationParams } from "./common";
import {
  ParticipantMedicationRequest,
  ParticipantMedicationRequestStatus,
} from "@sizdevteam1/funjoiner-web-shared/features/medical/baseline-questions/participant-medication-request.interface";
import { CreateParticipantMedicationDTO } from "@sizdevteam1/funjoiner-web-shared/features/medical/baseline-questions/medications/MedicationBaselineQuestion";

export interface GetMedicationRequestsByStudentIdParams {
  statuses: ParticipantMedicationRequestStatus[] | undefined;
}

export const getMedicationRequestsByStudentId = (
  studentId: number,
  searchParams: GetMedicationRequestsByStudentIdParams,
  paginationParams: IPaginationParams,
) => {
  return apiService.get<IPagination<ParticipantMedicationRequest>>(
    `/customer_api/v2/medication_requests/student/${studentId}`,
    { searchParams: { ...searchParams, ...paginationParams } },
  );
};

export const getMedicationRequestsSinglePageByStudentId = async (
  studentId: number,
  searchParams: GetMedicationRequestsByStudentIdParams = {
    statuses: undefined,
  },
) => {
  const pagination = await apiService.get<
    IPagination<ParticipantMedicationRequest>
  >(`/customer_api/v2/medication_requests/student/${studentId}`, {
    searchParams: {
      ...searchParams,
      limit: 100,
      offset: 0,
    },
  });

  return pagination.items;
};

export const submitNewMedicationRequest = (
  studentId: number,
  dto: CreateParticipantMedicationDTO,
) => {
  return apiService.post<ParticipantMedicationRequest>(
    "/customer_api/v2/medication_requests/",
    {
      data: {
        student_id: studentId,
        create_medication_dto: dto,
      },
    },
  );
};

export const editRequestedMedication = (
  medRequestId: string,
  data: CreateParticipantMedicationDTO,
) => {
  return apiService.post<ParticipantMedicationRequest>(
    `/customer_api/v2/medication_requests/${medRequestId}/edit_requested_medication`,
    {
      data,
    },
  );
};
export const withdrawMedicationRequest = (medRequestId: string) => {
  return apiService.post<ParticipantMedicationRequest>(
    `/customer_api/v2/medication_requests/${medRequestId}/withdraw`,
  );
};
